const Util = require('@antv/f2/lib/util/common')
const Helper = require('@antv/f2/lib/util/helper')
const List = require('@antv/f2/lib/component/list')
const Global = require('@antv/f2/lib/global')
const Legend = require('@antv/f2/lib/plugin/legend')

//直接引入
const Hammer = require('hammerjs')

// if (!Util.isWx && !Util.isMy) {
//   // todo import
// }
const isHorizontal = position => position === 'top' || position === 'bottom'

const TOUCH_EVENTS = [
  'touchstart',
  'touchmove',
  'touchend'
]

const LEGEND_GAP = 12
const MARKER_SIZE = 3
const INDICATOR_WIDTH = 20

const DEFAULT_CFG = {
  itemMarginBottom: 12,
  itemGap: 10,
  showTitle: false,
  titleStyle: {
    fontSize: 12,
    fill: '#808080',
    textAlign: 'start',
    textBaseline: 'top'
  },
  nameStyle: {
    fill: '#808080',
    fontSize: 12,
    textAlign: 'start',
    textBaseline: 'middle'
  },
  valueStyle: {
    fill: '#000000',
    fontSize: 12,
    textAlign: 'start',
    textBaseline: 'middle'
  },
  unCheckStyle: {
    fill: '#bfbfbf'
  },
  itemWidth: 'auto',
  wordSpace: 6,
  selectedMode: 'multiple' // 'multiple' or 'single'
}

class SingleRowList extends List {
  constructor(cfg) {
    super(cfg)
    this._renderIndicators()
  }

  getPlot() {
    const { container, maxLength, position } = this
    const x = container.get('x')
    const y = container.get('y')
    const { width, height, x: containerX, y: containerY } = container.getBBox()
    const horizontal = isHorizontal(position)

    return {
      tl: {
        x: x + containerX,
        y: y + containerY + (horizontal ? -10 : 0)
      },
      br: {
        x: x + containerX + (horizontal ? maxLength : width),
        y: y + containerY + (horizontal ? height + 10 : maxLength),
      },
      tr: {
        x: x + containerX + (horizontal ? maxLength : width),
        y: y + containerY + (horizontal ? -10 : 0),
      },
    }
  }
  _adjustHorizontal() {
    const { itemsGroup } = this

    const children = itemsGroup.get('children')
    const { itemGap, itemMarginBottom } = this
    const titleHeight = this._titleHeight

    const row = 0
    let rowWidth = 0
    let width
    let height
    const legendHitBoxes = []
    for (let i = 0, len = children.length; i < len; i++) {
      const child = children[i]
      const box = child.getBBox()
      const childHeight = box.height
      const childWidth = box.width
      width = childWidth + ((i === len - 1) ? 0 : itemGap)
      height = childHeight + itemMarginBottom

      child.moveTo(rowWidth, row * height)
      legendHitBoxes.push({
        x: rowWidth,
        y: (row * height) + titleHeight - (childHeight / 2),
        width,
        height: childHeight * 1.375
      })
      rowWidth += width
    }
    this.legendHitBoxes = legendHitBoxes
  }

  _renderIndicators() {
    const { container, position, wrapper, chart, maxLength } = this
    const horizontal = isHorizontal(position)
    const { width, height } = container.getBBox()
    const appendPadding = Util.parsePadding(chart.get('appendPadding'))

    if ((horizontal && width <= maxLength) || (!horizontal && height <= maxLength)) return

    this.firstIndicator = wrapper.addShape('rect', {
      attrs: {
        x: horizontal ? -appendPadding[3] : -width / 0, // 矩形左上角 x 坐标
        y: horizontal ? -height / 2 : 0, // 矩形左上角 y 坐标
        height: horizontal ? height : INDICATOR_WIDTH, // 矩形高度
        width: horizontal ? INDICATOR_WIDTH : width, // 矩形宽度
        lineWidth: 0, // html5 canvas 绘图属性
        fill: 'l(1) 0:rgba(255,255,255,0) 1:rgba(255,255,255,0)', // html5 canvas 绘图属性
        strokeWidth: 0,
        visible: false,
      }
    })
    this.firstIndicator.hide()

    this.lastIndicator = wrapper.addShape('rect', {
      attrs: {
        x: horizontal ? maxLength + appendPadding[1] - INDICATOR_WIDTH : -width / 2, // 矩形左上角 x 坐标
        y: horizontal ? -height / 2 : 0, // 矩形左上角 y 坐标
        height: horizontal ? height : INDICATOR_WIDTH, // 矩形高度
        width: horizontal ? INDICATOR_WIDTH : width, // 矩形宽度
        lineWidth: 0, // html5 canvas 绘图属性
        fill: 'l(1) 0:rgba(255,255,255,0) 1:rgba(255,255,255,0)', // html5 canvas 绘图属性
        strokeWidth: 0,
        visible: false,
      }
    })
    this.lastIndicator.show()
  }

  hideIndicators() {
    const { firstIndicator, lastIndicator } = this
    firstIndicator && firstIndicator.hide()
    lastIndicator && lastIndicator.hide()
  }

  updateIndicators(deltaX, deltaY) {
    this.updateFirstIndicator(deltaX, deltaY)
    this.updateLastIndicator(deltaX, deltaY)
  }

  updateFirstIndicator(x, y) {
    const { firstIndicator } = this
    if (!firstIndicator) return
    firstIndicator.translate(x, y)
    firstIndicator.show()
  }

  updateLastIndicator(x, y) {
    const { lastIndicator } = this
    if (!lastIndicator) return
    lastIndicator.translate(x, y)
    lastIndicator.show()
  }

  resetFirstIndicator(mt) {
    const { firstIndicator } = this
    if (!firstIndicator) return

    firstIndicator.setMatrix(mt)
    firstIndicator.hide()
  }

  resetLastIndicator(mt) {
    const { lastIndicator } = this
    if (!lastIndicator) return

    lastIndicator.setMatrix(mt)
    // lastIndicator.hide()
  }
}

// Register the default configuration for Legend
Global.legend = Util.deepMix({
  common: DEFAULT_CFG, // common legend configuration
  right: Util.mix({
    position: 'right',
    layout: 'vertical'
  }, DEFAULT_CFG),
  left: Util.mix({
    position: 'left',
    layout: 'vertical'
  }, DEFAULT_CFG),
  top: Util.mix({
    position: 'top',
    layout: 'horizontal'
  }, DEFAULT_CFG),
  bottom: Util.mix({
    position: 'bottom',
    layout: 'horizontal'
  }, DEFAULT_CFG)
}, Global.legend || {})

function getPaddingByPos(pos, appendPadding) {
  let padding = 0
  appendPadding = Util.parsePadding(appendPadding)
  switch (pos) {
    case 'top':
      padding = appendPadding[0]
      break
    case 'right':
      padding = appendPadding[1]
      break
    case 'bottom':
      padding = appendPadding[2]
      break
    case 'left':
      padding = appendPadding[3]
      break
    default:
      break
  }

  return padding
}

class ScrollableLegendController {
  constructor(cfg) {
    this.legendCfg = {}
    this.enable = true
    this.position = 'top'
    this.chart = null
    Util.mix(this, cfg)
    const { chart } = this
    this.canvasDom = chart.get('canvas').get('el')
    this.clear()

    this.currentDeltaX = null
    this.currentDeltaY = null
    this.lastPoint = null
    this.activeLegend = null
    this.prevMatrix = null
    this.needUpdateLegend = null
    this._timestamp = 0
  }

  addLegend(scale, items, filteredVals) {
    const self = this
    const { legendCfg } = self
    const { field } = scale
    const fieldCfg = legendCfg[field]
    if (fieldCfg === false) {
      return
    }

    if (fieldCfg && fieldCfg.custom) {
      self.addCustomLegend(field)
    } else {
      let position = legendCfg.position || self.position
      if (fieldCfg && fieldCfg.position) {
        // eslint-disable-next-line prefer-destructuring
        position = fieldCfg.position
      }
      if (scale.isCategory) {
        self._addCategoryLegend(scale, items, position, filteredVals)
      }
    }
  }

  addCustomLegend(field) {
    const self = this

    let { legendCfg } = self
    if (field && legendCfg[field]) {
      legendCfg = legendCfg[field]
    }

    const position = legendCfg.position || self.position
    const { legends } = self
    legends[position] = legends[position] || []
    const { items } = legendCfg
    if (!items) {
      return
    }

    const { container } = self
    Util.each(items, (item) => {
      if (!Util.isPlainObject(item.marker)) {
        item.marker = {
          symbol: item.marker || 'circle',
          fill: item.fill,
          radius: MARKER_SIZE
        }
      } else {
        item.marker.radius = item.marker.radius || MARKER_SIZE
      }
      item.checked = Util.isNil(item.checked) ? true : item.checked
      item.name = item.name || item.value
    })
    const legend = new SingleRowList(Util.deepMix({}, Global.legend[position], legendCfg, {
      maxLength: self._getMaxLength(position),
      items,
      parent: container,
      chart: this.chart,
    }))
    legends[position].push(legend)
  }

  clear() {
    const { legends } = this
    Util.each(legends, (legendItems) => {
      Util.each(legendItems, (legend) => {
        legend.clear()
      })
    })

    this.legends = {}
    this.unBindEvents()
  }

  _isFiltered(scale, values, value) {
    let rst = false
    Util.each(values, (val) => {
      rst = rst || scale.getText(val) === scale.getText(value)
      if (rst) {
        return false
      }
      return undefined // sonar
    })
    return rst
  }

  _getMaxLength(position) {
    const { chart } = this
    const appendPadding = Util.parsePadding(chart.get('appendPadding'))

    return (position === 'right' || position === 'left') ?
      chart.get('height') - (appendPadding[0] + appendPadding[2]) :
      chart.get('width') - (appendPadding[1] + appendPadding[3])
  }

  _addCategoryLegend(scale, items, position, filteredVals) {
    const self = this
    const { legendCfg, legends, container, chart } = self
    const { field } = scale
    legends[position] = legends[position] || []

    let symbol = 'circle'
    if (legendCfg[field] && legendCfg[field].marker) {
      symbol = legendCfg[field].marker
    } else if (legendCfg.marker) {
      symbol = legendCfg.marker
    }

    Util.each(items, (item) => {
      if (Util.isPlainObject(symbol)) {
        Util.mix(item.marker, symbol)
      } else {
        item.marker.symbol = symbol
      }

      if (filteredVals) {
        item.checked = !self._isFiltered(scale, filteredVals, item.dataValue)
      }
    })

    const legendItems = chart.get('legendItems')
    legendItems[field] = items

    const lastCfg = Util.deepMix({}, Global.legend[position], legendCfg[field] || legendCfg, {
      maxLength: self._getMaxLength(position),
      items,
      field,
      filteredVals,
      parent: container,
      chart,
    })
    if (lastCfg.showTitle) {
      Util.deepMix(lastCfg, {
        title: scale.alias || scale.field
      })
    }

    // 判断如果 position 一致，默认为双轴，把两个轴的合并
    if (legends[position].length > 0) {
      const singleRowList = legends[position][0]
      const { items: zAxisItems, field: zAxisField } = lastCfg
      const newItems = zAxisItems.map(d => ({ ...d, field: zAxisField }))
      singleRowList.items.push(...newItems)
      if (singleRowList.itemsGroup) {
        singleRowList.itemsGroup.clear()
        singleRowList._renderItems()
      }
      return singleRowList
    } else {
      const legend = new SingleRowList(lastCfg)
      self.needUpdateLegend = legend
      legends[position].push(legend)
      return legend
    }
  }

  _alignLegend(legend, pre, position) {
    const self = this
    const { tl, bl } = self.plotRange
    const { chart } = self
    let offsetX = legend.offsetX || 0
    let offsetY = legend.offsetY || 0
    const chartWidth = chart.get('width')
    const chartHeight = chart.get('height')
    const appendPadding = Util.parsePadding(chart.get('appendPadding'))
    const legendHeight = legend.getHeight()
    const legendWidth = legend.getWidth()

    let x = 0
    let y = 0
    if (position === 'left' || position === 'right') {
      const verticalAlign = legend.verticalAlign || 'middle'
      const height = Math.abs(tl.y - bl.y)
      x = (position === 'left') ? appendPadding[3] : (chartWidth - legendWidth - appendPadding[1])
      y = ((height - legendHeight) / 2) + tl.y
      if (verticalAlign === 'top') {
        // eslint-disable-next-line prefer-destructuring
        y = tl.y
      } else if (verticalAlign === 'bottom') {
        y = bl.y - legendHeight
      }

      if (pre) {
        y = pre.get('y') - legendHeight - LEGEND_GAP
      }
    } else {
      const align = legend.align || 'left'
      x = appendPadding[3]

      if (align === 'center') {
        x = (chartWidth / 2) - (legendWidth / 2)
      } else if (align === 'right') {
        x = chartWidth - (legendWidth + appendPadding[1])
      }
      y = (position === 'top') ? appendPadding[0] + Math.abs(legend.container.getBBox().minY) : (chartHeight - legendHeight)
      if (pre) {
        const preWidth = pre.getWidth()
        x = pre.x + preWidth + LEGEND_GAP
      }
    }
    if (position === 'bottom' && offsetY > 0) {
      offsetY = 0
    }
    if (position === 'right' && offsetX > 0) {
      offsetX = 0
    }
    legend.moveTo(x + offsetX, y + offsetY)
    if (legend === this.needUpdateLegend && this.prevMatrix) {
      legend.container.setMatrix(this.prevMatrix)
      this.needUpdateLegend = null
      const horizontal = isHorizontal(position)
      const translateX = this.prevMatrix[4] - legend.x
      // const translateY = this.prevMatrix[5] - legend.x

      const { width } = legend.container.getBBox()
      const maxLength = this._getMaxLength(position)

      if (horizontal) {
        if (translateX >= appendPadding[3]) {
          legend.resetFirstIndicator([1, 0, 0, 1, 0, 0])
          legend.updateLastIndicator(-translateX, 0)
        } else if (translateX <= maxLength - width + appendPadding[1]) {
          legend.resetLastIndicator([1, 0, 0, 1, width - maxLength, 0])
          legend.updateFirstIndicator(-translateX, 0)
        } else {
          legend.updateIndicators(-translateX, 0)
        }
      }

      this.prevMatrix = null
    }
  }

  alignLegends() {
    const self = this
    const { legends } = self
    Util.each(legends, (legendItems, position) => {
      Util.each(legendItems, (legend, index) => {
        const pre = legendItems[index - 1]
        self._alignLegend(legend, pre, position)

        const { width, height } = legend.container.getBBox()
        const horizontal = isHorizontal(position)
        const maxLength = this._getMaxLength(position)
        if ((horizontal && width < maxLength) || (!horizontal && height < maxLength)) {
          legend.container.setTransform([['t', legend.x + (horizontal ? (maxLength - width) / 2 : 0), legend.y + (!horizontal ? (maxLength - height) / 2 : 0)]])
        }
      })
    })

    return self
  }

  handleEvent(ev) {
    const self = this
    if (self.activeLegend) return

    let fakeEvent = ev

    if (!ev.targetTouches || ev.targetTouches.length <= 0) {
      fakeEvent = { ...ev }
      fakeEvent.targetTouches = ev.changedTouches
    }

    function findItem(xItem, yItem) {
      let result = null
      const { legends } = self
      Util.each(legends, (legendItems) => {
        Util.each(legendItems, (legend) => {
          const { itemsGroup, legendHitBoxes } = legend
          const children = itemsGroup.get('children')
          if (children.length) {
            const matrix = legend.container.attr('matrix')
            const translateX = matrix[4]
            const translateY = matrix[5]
            Util.each(legendHitBoxes, (box, index) => {
              if (xItem >= (box.x + translateX) && xItem <= (box.x + box.width + translateX) && yItem >= (box.y + translateY) && yItem <= (box.height + box.y + translateY)) { // inbox
                result = {
                  clickedItem: children[index],
                  clickedLegend: legend
                }
                return false
              }
              return undefined // sonar
            })
          }
        })
      })
      return result
    }

    const { chart } = self
    const { x, y } = Util.createEvent(fakeEvent, chart)
    const clicked = findItem(x, y)
    if (clicked && clicked.clickedLegend.clickable !== false) {
      this.prevMatrix = clicked.clickedLegend.container.attr('matrix')
      const { clickedItem, clickedLegend } = clicked
      if (clickedLegend.onClick) {
        ev.clickedItem = clickedItem
        clickedLegend.onClick(ev)
      } else if (!clickedLegend.custom) {
        const checked = clickedItem.get('checked')
        const value = clickedItem.get('dataValue')
        const { filteredVals, field, selectedMode, items } = clickedLegend
        const isSingeSelected = selectedMode === 'single'

        const item = items.find(d => d.dataValue === value)
        const activeField = (item && item.field) || field

        if (isSingeSelected) {
          chart.filter(activeField, val => val === value)
        } else {
          if (checked) {
            filteredVals.push(value)
          } else {
            Util.Array.remove(filteredVals, value)
          }

          chart.filter(activeField, val => filteredVals.indexOf(val) === -1)
        }

        chart.repaint()
      }
    }
  }

  _bindEvent(eventName, methodName) {
    const el = this.canvasDom
    if (eventName) {
      if (TOUCH_EVENTS.indexOf(eventName) !== -1) {
        Util.addEventListener(el, eventName, Util.wrapBehavior(this, methodName))
      } else if (this.hammer) {
        this.hammer.on(eventName, Util.wrapBehavior(this, methodName))
      }
    }
  }
  bindEvents() {
    this.unBindEvents()
    const { legendCfg } = this
    const triggerOn = legendCfg.triggerOn || 'touchend'
    const method = Util.wrapBehavior(this, 'handleEvent')
    Util.addEventListener(this.canvasDom, triggerOn, method)

    if (legendCfg.designTime) return

    if (Hammer) {
      this.hammer = new Hammer(this.canvasDom)
    }
    this._bindEvent(Util.isWx || Util.isMy ? 'touchstart' : 'panstart', 'panStart')
    this._bindEvent(Util.isWx || Util.isMy ? 'touchmove' : 'panmove', 'panProcess')
    this._bindEvent(Util.isWx || Util.isMy ? 'touchend' : 'panend', 'panEnd')
  }

  unBindEvents() {
    const { legendCfg } = this
    const triggerOn = legendCfg.triggerOn || 'touchend'
    const method = Util.getWrapBehavior(this, 'handleEvent')
    Util.removeEventListener(this.canvasDom, triggerOn, method)
    if (this.hammer) {
      this.hammer.destroy()
      this.hammer = null
    } else {
      Util.removeEventListener(this.canvasDom, 'touchstart', Util.getWrapBehavior(this, 'panStart'))
      Util.removeEventListener(this.canvasDom, 'touchmove', Util.getWrapBehavior(this, 'panProcess'))
      Util.removeEventListener(this.canvasDom, 'touchend', Util.getWrapBehavior(this, 'panEnd'))
    }
  }

  getActiveLegend(e) {
    const legends = Object.values(this.legends).reduce((acc, items) => [...acc, ...items], [])
    const canvasPoint = Util.getRelativePosition(e.center, this.chart.get('canvas'))
    const activeLegend = legends.find(d => Helper.isPointInPlot(canvasPoint, d.getPlot()))
    return activeLegend || null
  }

  panStart(e) {
    // 检查是否是在图例中触发动作
    const activeLegend = this.getActiveLegend(e)
    if (!activeLegend) return
    if (activeLegend.clickable === false) return
    this.activeLegend = activeLegend
    this.currentDeltaX = 0
    this.currentDeltaY = 0
    if (e.type === 'touchstart' || e.type === 'touchStart') {
      this.lastPoint = e.touches[0]
    }
    this._handleMove(e)
  }

  panProcess(e) {
    if (!this.activeLegend) return
    this._handleMove(e)
  }

  panEnd() {
    this.currentDeltaX = null
    this.currentDeltaY = null
    this.lastPoint = null
    setTimeout(() => {
      this.activeLegend = null
    }, 0)
  }

  _handleMove(e) {
    if (!this.activeLegend) return

    const { position, activeLegend } = this
    const { width, height } = activeLegend.container.getBBox()
    const horizontal = isHorizontal(position)
    const maxLength = this._getMaxLength(position)
    if ((horizontal && width <= maxLength) || (!horizontal && height <= maxLength)) return

    if (e.type === 'swipe' && e.deltaTime > 350) { // 区分 pan 操作和 swipe 操作
      return
    }
    const { currentDeltaX, currentDeltaY, lastPoint } = this
    let deltaX
    let deltaY
    if (TOUCH_EVENTS.indexOf(e.type) !== -1) { // support touch and mini program
      const currentPoint = e.touches[0]
      deltaX = currentPoint.x - lastPoint.x
      deltaY = currentPoint.y - lastPoint.y
      this.lastPoint = currentPoint
    } else if (currentDeltaX !== null && currentDeltaY !== null) {
      deltaX = e.deltaX - currentDeltaX
      deltaY = e.deltaY - currentDeltaY
      this.currentDeltaX = e.deltaX
      this.currentDeltaY = e.deltaY
    }

    if (Math.abs(deltaX) > 0 || Math.abs(deltaY) > 0) {
      const lastTimestamp = this._timestamp
      const now = +new Date()
      if ((now - lastTimestamp) > 16) {
        this._doMove(deltaX, deltaY)
        this._timestamp = now
      }
    }
  }

  _doMove(deltaX, deltaY) {
    const { activeLegend, position } = this
    if (!activeLegend) return
    activeLegend.hideIndicators()
    const matrix = activeLegend.container.attr('matrix')
    const { width, height } = activeLegend.container.getBBox()
    const horizontal = isHorizontal(position)
    const maxLength = this._getMaxLength(position)
    const appendPadding = Util.parsePadding(this.chart.get('appendPadding'))

    let translateX = deltaX
    let translateY = deltaY

    if (horizontal) {
      if (matrix[4] + deltaX >= appendPadding[3]) {
        translateX = appendPadding[3] - matrix[4]
        activeLegend.resetFirstIndicator([1, 0, 0, 1, 0, 0])
        activeLegend.updateLastIndicator(-translateX, 0)
      } else if (matrix[4] + deltaX <= maxLength - width + appendPadding[1]) {
        translateX = maxLength - width + appendPadding[1] - matrix[4]
        activeLegend.resetLastIndicator([1, 0, 0, 1, width - maxLength, 0])
        activeLegend.updateFirstIndicator(-translateX, 0)
      } else {
        activeLegend.updateIndicators(-translateX, 0)
      }
      activeLegend.container.translate(translateX, 0)
    } else {
      if (matrix[5] + deltaY > appendPadding[0]) {
        translateY = appendPadding[0] - matrix[5]
      } else if (matrix[5] + deltaY < maxLength - height) {
        translateY = maxLength - height - matrix[5]
      }
      activeLegend.container.translate(0, translateY)
    }
    this.chart.get('canvas').draw()
  }
}
const ScrollableLegendPlugin = {
  init(chart) {
    const scrollableLegendController = new ScrollableLegendController({
      container: chart.get('backPlot'),
      plotRange: chart.get('plotRange'),
      chart
    })
    chart.set('scrollableLegendController', scrollableLegendController)

    chart.scrollableLegend = function (field, cfg) {
      let { legendCfg } = scrollableLegendController
      scrollableLegendController.enable = true

      if (Util.isBoolean(field)) {
        scrollableLegendController.enable = field
        legendCfg = cfg || {}
      } else if (Util.isObject(field)) {
        legendCfg = field
      } else {
        legendCfg[field] = cfg
      }

      scrollableLegendController.legendCfg = legendCfg
      return this
    }
  },
  beforeGeomDraw(chart) {
    const legendController = chart.get('scrollableLegendController')
    if (!legendController.enable) return // legend is not displayed

    const { legendCfg } = legendController

    if (legendCfg && legendCfg.custom) {
      legendController.addCustomLegend()
    } else {
      const legendItems = chart.getLegendItems()
      const scales = chart.get('scales')
      const filters = chart.get('filters')
      Util.each(legendItems, (items, field) => {
        const scale = scales[field]
        const { values } = scale
        let filteredVals
        if (filters && filters[field]) {
          filteredVals = values.filter(v => !filters[field](v))
        } else {
          filteredVals = []
        }
        legendController.addLegend(scale, items, filteredVals)
      })
    }

    if (legendCfg && legendCfg.clickable !== false) {
      legendController.bindEvents()
    }

    const { legends } = legendController
    const legendRange = {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
    Util.each(legends, (legendItems, position) => {
      let padding = 0
      Util.each(legendItems, (legend) => {
        const width = legend.getWidth()
        const height = legend.getHeight()
        if (position === 'top' || position === 'bottom') {
          padding = Math.max(padding, height)
          if (legend.offsetY > 0) {
            padding += legend.offsetY
          }
        } else {
          padding = Math.max(padding, width)
          if (legend.offsetX > 0) {
            padding += legend.offsetX
          }
        }
      })
      legendRange[position] = padding + getPaddingByPos(position, chart.get('appendPadding'))
    })
    chart.set('legendRange', legendRange)
  },
  afterGeomDraw(chart) {
    const legendController = chart.get('scrollableLegendController')
    legendController.alignLegends()
  },
  clearInner(chart) {
    const legendController = chart.get('scrollableLegendController')
    legendController.clear()
    chart.set('legendRange', null)
  }
}

export default (F2) => {
  F2.Chart.plugins.unregister(Legend)
  F2.Chart.plugins.register([ScrollableLegendPlugin])
}
